<nz-layout class="app-layout">
    <nz-sider class="menu-sidebar" nzWidth="260px" [nzCollapsed]="isCollapsed">
        <div class="sidebar-logo">
            <a routerLink="/" nz-button nzType="link" nzBlock href="/">
                @if (isCollapsed) {
                    <span>PT</span>
                } @else {
                    <span>Price Tracker</span>
                }
            </a>
        </div>

        <app-navigation [isCollapsed]="isCollapsed" />
    </nz-sider>
    <nz-layout
        [class]="{
            layout: true,
            collapsed: isCollapsed,
        }"
    >
        <nz-header>
            <div class="app-header">
                <nz-row
                    [class]="{
                        'app-header__row': true,
                        'app-header__row--collapsed': isCollapsed,
                    }"
                    nzJustify="space-between"
                >
                    <nz-col [nzSpan]="20">
                        <button
                            class="header-toggle"
                            nz-button
                            nzType="text"
                            (click)="collapsedChanged()"
                        >
                            <nz-icon
                                class="trigger"
                                [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
                            />
                        </button>
                    </nz-col>
                    <nz-col class="app-header__right-actions" [nzSpan]="4">
                        <button
                            nz-button
                            nzType="text"
                            nz-dropdown
                            nzTrigger="click"
                            class="profile-menu-icon"
                            [nzDropdownMenu]="profileMenu"
                        >
                            <nz-icon nzType="user" nzTheme="outline" />
                        </button>
                        <nz-dropdown-menu class="profile-menu" #profileMenu="nzDropdownMenu">
                            <ul nz-menu>
                                <div nz-menu-item class="profile-menu__item">
                                    <div
                                        [nzGutter]="[30, 0]"
                                        nz-row
                                        nzJustify="center"
                                        nzAlign="middle"
                                    >
                                        <div nz-col nzSpan="4">
                                            <nz-typography>
                                                <nz-icon
                                                    class="profile-menu-icon second"
                                                    style="font-size: 20px"
                                                    nzType="user"
                                                    nzTheme="outline"
                                                />
                                            </nz-typography>
                                        </div>
                                        <div nz-col nzSpan="18">
                                            <div>
                                                {{ user?.first_name }} {{ user?.last_name }}
                                                <div>
                                                    <nz-typography [nzType]="'secondary'">
                                                        {{ user?.role?.name }}
                                                    </nz-typography>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <li nz-menu-divider></li>
                                <button
                                    nzType="text"
                                    routerLink="/profile"
                                    nz-menu-item
                                    class="profile-menu__item"
                                >
                                    <div>
                                        <nz-icon nzType="profile" nzTheme="outline" />
                                        Profile
                                    </div>
                                </button>
                                <button nz-menu-item (click)="logout()" class="profile-menu__item">
                                    <div>
                                        <nz-icon nzType="logout" nzTheme="outline" />
                                        Logout
                                    </div>
                                </button>
                            </ul>
                        </nz-dropdown-menu>
                    </nz-col>
                </nz-row>
            </div>
        </nz-header>
        <nz-content>
            <div
                [class]="{
                    'inner-content': true,
                    loading: loaderService.state(),
                }"
            >
                <router-outlet></router-outlet>
                @if (loaderService.state()) {
                    <app-loader [contentLoader]="true" />
                }
            </div>
        </nz-content>
    </nz-layout>
</nz-layout>
